import React from 'react';
import { Route } from 'react-router-dom';
import {ShopItem} from "./ui/shops/shop-item/shop-item";
import {ShopsContainer} from "./ui/shops/shops-page/shops-page-container";

function App() {
  return (
    <div>
      <Route path={'/shops/:id'} render={() => <ShopItem/>}/>
      <Route exact path={'/shops'} render={() => <ShopsContainer/>}/>
    </div>
  );
}

export default App;
